import './masthead_component.scss'
